export default __webpack_public_path__ + "graphics/union-pay.d50b6303.jpg";